import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { db } from '../../config/firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import logoImage from '../../assets/logo_image.png';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const [contactInfo, setContactInfo] = useState({
    address: 'Cevdetpaşa Caddesi 101, Bebek, Istanbul',
    phone: '+90 (538) 321 98 98',
    email: 'simon@bosphorusyachts.com'
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsDoc = await getDoc(doc(db, 'settings', 'homepage'));
        if (settingsDoc.exists()) {
          const { contactInfo } = settingsDoc.data();
          setContactInfo(contactInfo);
        }
      } catch (error) {
        console.error('Error fetching contact info:', error);
      }
    };

    fetchSettings();
  }, []);

  return (
    <footer className="premium-footer">
      <div className="footer-glow" />
      
      <div className="footer-container">
        <div className="footer-main">
          {/* Brand Column */}
          <div className="footer-brand">
            <RouterLink to="/" className="footer-logo">
              <img src={logoImage} alt="Bosphorus Yachts" className="footer-logo-image" />
              <span className="footer-logo-text">
                Bosphorus <span className="logo-accent">Affiliates</span>
              </span>
            </RouterLink>
            <p className="footer-tagline">
              Partner with Istanbul's premier yacht rental service and earn commissions on every booking.
            </p>
            <div className="footer-social">
              <a 
                href="https://www.instagram.com/bosphorusyachts" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
              <a 
                href="https://twitter.com/bosphorusyachts" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Twitter"
              >
                <TwitterIcon />
              </a>
              <a 
                href="https://youtube.com/@bosphorusyachts" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="YouTube"
              >
                <YouTubeIcon />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links-column">
            <h4 className="footer-column-title">Quick Links</h4>
            <nav className="footer-nav">
              <RouterLink to="/" className="footer-link">Home</RouterLink>
              <RouterLink to="/experiences" className="footer-link">Experiences</RouterLink>
              <RouterLink to="/login" className="footer-link">Login</RouterLink>
              <RouterLink to="/signup" className="footer-link">Become a Partner</RouterLink>
            </nav>
          </div>

          {/* Resources */}
          <div className="footer-links-column">
            <h4 className="footer-column-title">Resources</h4>
            <nav className="footer-nav">
              <a 
                href="https://bosphorusyachts.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-link"
              >
                Bosphorus Yachts
              </a>
              <a 
                href="https://drive.google.com/drive/folders/1uCUYEb9MrcgZMyn5evbeZ1JKOUVkZHbx?usp=sharing" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-link"
              >
                Partner Files
              </a>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="footer-contact-column">
            <h4 className="footer-column-title">Contact</h4>
            <div className="footer-contact-list">
              <div className="contact-item">
                <LocationOnIcon className="contact-icon" />
                <span>{contactInfo.address}</span>
              </div>
              <div className="contact-item">
                <PhoneIcon className="contact-icon" />
                <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
              </div>
              <div className="contact-item">
                <EmailIcon className="contact-icon" />
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 Bosphorus Yachts. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <span className="footer-divider">|</span>
            <span className="made-with">Made with excellence in Istanbul</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
